import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Projects.css";
import { fetchCaseStudies } from "../services/airtable";
import staticCaseStudies from "./caseStudiesData";
import Navigation from "./Navigation";

export default function Projects() {
  const [caseStudies, setCaseStudies] = useState(staticCaseStudies);

  useEffect(() => {
    const loadCaseStudies = async () => {
      try {
        const airtableData = await fetchCaseStudies();
        if (airtableData && airtableData.length > 0) {
          // Show ALL published case studies (not just featured ones)
          const transformedData = airtableData.map(study => ({
            clientName: study.clientName,
            title: study.title,
            description: study.subtitle,
            slug: study.slug,
            image: study.heroImageUrl || require('../assets/cjm2.png')
          }));
          setCaseStudies(transformedData);
        }
      } catch (error) {
        console.error('Failed to load case studies from Airtable, using static data:', error);
      }
    };

    loadCaseStudies();
  }, []);
  return (
    <div className="projects-page">
      <Navigation />
      <div className="projects-header">
        <h1>All Case Studies</h1>
        <p>Explore my complete portfolio of digital product strategy and design work</p>
      </div>
      <div className="projects-grid">
        {caseStudies.map((caseStudy, i) => (
          <div className="project-card small-card" key={i}>
            <div className="project-image-container">
              <img 
                src={caseStudy.image || (caseStudy.images && caseStudy.images[0])} 
                alt={caseStudy.title} 
                className="project-image" 
              />
            </div>
            <div className="project-content">
              {caseStudy.clientName && <div className="client-name">{caseStudy.clientName}</div>}
              <h3>{caseStudy.title}</h3>
              <p>{caseStudy.description ? (() => {
                let cleanedText = caseStudy.description.replace(/\|\*\|\*/g, '**').replace(/\\\*\\\*/g, '**');
                return cleanedText.includes('**') ? 
                  cleanedText.split(/(\*\*.*?\*\*)/).map((part, index) => 
                    part.startsWith('**') && part.endsWith('**') ? 
                      <strong key={index}>{part.slice(2, -2)}</strong> : part
                  ) : cleanedText;
              })() : ''}</p>
              {caseStudy.slug ? (
                <Link to={`/case-studies/${caseStudy.slug}`} className="btn btn-primary">
                  View Study
                </Link>
              ) : (
                <span className="btn btn-primary" style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  Coming Soon
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 